import React from 'react';

import RootStack from './components/RootStack';

import authRoutes from './stacks/auth';
import appRoutes from './stacks/getApp';
import maintenanceRoutes from './stacks/maintenance';
import { StackConfig } from './type';

export const rootStack: StackConfig[] = [
    { base: '/auth', stack: authRoutes, auth: false },
    { base: '/app', stack: appRoutes, isPublic: true },
    { base: '', stack: maintenanceRoutes, isPublic: true },
];

const Routes = () => <RootStack stack={rootStack} />;

export default Routes;
